import {useIntl} from 'react-intl';
import {useMediaQuery, useTheme} from '@mui/material';

export const useWidth = () => {
  const theme = useTheme();

  // Call hooks in a fixed order (top-level only)
  const upSm = useMediaQuery(theme.breakpoints.up('sm'));
  const upMd = useMediaQuery(theme.breakpoints.up('md'));
  const upLg = useMediaQuery(theme.breakpoints.up('lg'));
  const upXl = useMediaQuery(theme.breakpoints.up('xl'));

  // Largest matching breakpoint wins
  if (upXl) return 'xl';
  if (upLg) return 'lg';
  if (upMd) return 'md';
  if (upSm) return 'sm';
  return 'xs';
};

export const getBreakPointsValue = (valueSet, breakpoint) => {
  if (typeof valueSet === 'number') return valueSet;
  switch (breakpoint) {
    case 'xs':
      return valueSet.xs;
    case 'sm':
      return valueSet.sm || valueSet.xs;
    case 'md':
      return valueSet.md || valueSet.sm || valueSet.xs;
    case 'lg':
      return valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs;
    default:
      return (
        valueSet.xl || valueSet.lg || valueSet.md || valueSet.sm || valueSet.xs
      );
  }
};

export const getFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = 2;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const multiPropsFilter = (products, filters, stringKey = 'title') => {
  const filterKeys = Object.keys(filters);
  return products.filter((product) =>
    filterKeys.every((key) => {
      if (!filters[key].length) return true;
      if (Array.isArray(product[key])) {
        return product[key].some((keyEle) => filters[key].includes(keyEle));
      }
      if (key === stringKey) {
        return product[key]
          ?.toString()
          ?.toLowerCase()
          .includes(filters[key].toString().toLowerCase());
      }
      return filters[key].includes(product[key]);
    }),
  );
};

// 'intl' service singleton reference
let intl;

export function IntlGlobalProvider({children}) {
  intl = useIntl();
  return children;
}

export const appIntl = () => intl;
